@if (actions.show && actions.options.length) {
  <div
    #nodeActions
    [style.max-width.px]="maxWidth"
    [style.transform]="actions.styles.transform"
    [style.margin-left.px]="-1 * (nodeActions.offsetWidth / 2)"
    [class]="readonly ? 'bg-neutral-700' : 'bg-blue-500'"
    class="node-actions absolute flex flex-wrap gap-2 text-white mt-1 px-2 py-2 rounded-lg z-50 text-sm font-semibold"
    data-testId="node-actions-panel"
  >
    @if (actions.displayItemsCount) {
      <div
        class="border-r border-white pr-2"
        data-testId="selected-nodes-count"
      >
        {{ actions.displayItemsCount }} {{ actions.displayItemsCount > 1 ? 'items' : 'item' }}
      </div>
    }

    <ng-template
      #barButton
      let-nodeAction
    >
      <button
        [attr.data-testId]="nodeAction.testId || nodeAction.label || nodeAction.icon"
        [class]="readonly ? 'hover:bg-neutral-600' : 'hover:bg-blue-400'"
        [pTooltip]="nodeAction.tooltip"
        [showDelay]="1000"
        (click)="nodeAction.command({ store })"
        class="flex justify-center items-center min-w-5 h-6 p-1 rounded cursor-pointer"
        tooltipPosition="top"
        clickStopPropagation
      >
        <flx-icon
          [name]="nodeAction.icon"
          [title]="nodeAction.label"
          class="!w-5 !h-5 text-white"
        ></flx-icon>

        @if (nodeAction.label) {
          <span class="pl-1">{{ nodeAction.label }} </span>
        }
      </button>
    </ng-template>

    @for (nodeAction of barActions; track $index) {
      <ng-container *ngTemplateOutlet="barButton; context: { $implicit: nodeAction }" />
    }

    @if (overflowActions.length) {
      <button
        [class.readonly]="readonly"
        (click)="openOverflow($event, overflowMenu)"
        class="flx-ds small ternary node-actions-more"
        data-testId="node-actions-more"
        flxButton
        icon="center"
        type="button"
        clickStopPropagation
        aria-label="More actions"
      >
        <i
          class="ph-bold ph-dots-three-vertical"
          flxIcon
        ></i>
      </button>
    }
  </div>
}

<p-menu
  #overflowMenu
  [model]="menuModel"
  [popup]="true"
  appendTo="body"
  styleClass="flx-prime-menu node-actions-menu"
>
  <ng-template
    #item
    let-item
  >
    <a
      [attr.data-testId]="item.automationId"
      class="p-menu-item-link node-actions-menu__item"
    >
      <span class="node-actions-menu__label">
        <i class="ph {{ item.icon }} node-actions-menu__icon"></i>
        {{ item.label }}
      </span>
      @if (item.state?.shortcut) {
        <span class="node-actions-menu__shortcut">{{ item.state.shortcut }}</span>
      }
    </a>
  </ng-template>
</p-menu>

@if (actions.showAiOptions) {
  <div
    #nodeAiActions
    [style.transform]="actions.styles.transform"
    [style.margin-left.px]="-1 * (nodeAiActions.offsetWidth / 2)"
    [style.margin-top.px]="nodeActionsPanelEl.offsetHeight + 8"
    [style.width.px]="nodeActionsPanelEl.offsetWidth + 16"
    class="absolute min-w-[192px] flex flex-col z-50 !gap-2 bg-white rounded p-2 shadow-[0_4px_16px_0_rgba(0,0,0,0.4)]"
  >
    @for (aiAction of actions.aiOptions; track $index) {
      <button
        [attr.data-testId]="aiAction.label"
        [ngClass]="{ 'opacity-30 !cursor-default': aiAction.disabled }"
        [disabled]="aiAction.disabled"
        [pTooltip]="aiAction.tooltip"
        (click)="aiAction.command()"
        class="flex gap-1 items-center text-xs font-semibold cursor-pointer rounded hover:bg-neutral-50"
        tooltipPosition="bottom"
        clickStopPropagation
      >
        <flx-icon
          [name]="aiAction.icon"
          class="!w-5 !h-5"
        ></flx-icon>
        {{ aiAction.label }}
      </button>
    }
  </div>
}
